import { render, staticRenderFns } from "./EditPageContactMain.vue?vue&type=template&id=05cac14d"
import script from "./EditPageContactMain.vue?vue&type=script&lang=js"
export * from "./EditPageContactMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports